"use client"

import { LEO_DEEP_FILL_CLASS, LeoIcon } from "@/components/ui/leo-icon"
import { cn } from "@/lib/utils"

export function LeoWorkStatus({
  label,
  detail,
}: {
  label: string
  detail?: string
}) {
  return (
    <div className="flex min-w-0 items-start gap-2">
      <span
        className={cn("mt-0.5 inline-flex shrink-0", LEO_DEEP_FILL_CLASS)}
        aria-hidden
      >
        <LeoIcon variant="ambient" size="xs" state="working" />
      </span>
      <div className="min-w-0">
        <p
          role="status"
          aria-live="polite"
          className="shimmer m-0 text-sm font-medium text-foreground"
        >
          {label}
        </p>
        {detail ? (
          <p className="m-0 mt-0.5 text-sm leading-5 text-muted-foreground">
            {detail}
          </p>
        ) : null}
      </div>
    </div>
  )
}
